import getAxios from './axios'

export const ssoApi = getAxios({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    AJAX: 'true'
  },
  withCredentials: true
})

export const api = getAxios({
  baseURL: process.env.VUE_APP_BASE_API_MGR,
  headers: {
    AJAX: 'true'
  },
  withCredentials: true
})
export const apiFormData = getAxios({
  baseURL: process.env.VUE_APP_BASE_API_MGR,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  withCredentials: true
})

export const apiConsole = getAxios({
  baseURL: process.env.VUE_APP_CONSOLE_API,
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  withCredentials: true
})

export const apiVerify = getAxios({
  baseURL: process.env.VUE_APP_BASE_API_MGR,
  headers: {
    AJAX: 'true'
  },
  withCredentials: true,
  loading: false
})

export const uploadApi = getAxios({
  baseURL: process.env.VUE_APP_UPLOAD_API,
  headers: {
    AJAX: 'true'
  },
  withCredentials: true,
  loading: false
})

// 快传插件模式
export const sdkApi = getAxios({
  baseURL: process.env.VUE_APP_SDK_API,
  loading: true,
  closeError: true
}, null)

export const sdkApiApiVerify = getAxios({
  baseURL: process.env.VUE_APP_SDK_API,
  loading: false,
  closeError: true
}, null)

export const wpApi = getAxios({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: process.env.VUE_APP_WP_API,
  headers: {
    AJAX: 'true'
  },
  withCredentials: true
})
